@if(showComponent()) {
    <div class="viewboard_industry_contractsstats w-full transition-all duration-200 delay-0 ease-in-out"
        [ngClass]="{'h-[30px] overflow-hidden':!showIndustryTable}">

        <!-- Responsive flex container -->
        <div class="flex flex-wrap justify-start gap-4 w-full relative transition-all duration-500 delay-500 ease-in-out">
            @for (industry of industryCards; track industry.label) {
                <app-cards 
                    [data]="contracts[industry.dataKey]"
                    [cardHeading]="industry.label"
                    [tableHeaders]="industry.tableHeaders"
                    [valueKey]="industry.valueKey"
                    [curveType]="'curveLinear'"
                    [isClassHide]="false"
                    [classWithoutBorder]="true"
                    [unit]="dateRange.unit || 'day'"
                    class="w-full sm:w-[100%] lg:w-[32%] flex-grow transition-all delay-500 ease-in-out duration-300">
                </app-cards>
            }
        </div>
    </div>
}